import { render, staticRenderFns } from "./EmptyChart.vue?vue&type=template&id=2998e896&scoped=true"
import script from "./EmptyChart.vue?vue&type=script&lang=ts"
export * from "./EmptyChart.vue?vue&type=script&lang=ts"
import style0 from "./EmptyChart.vue?vue&type=style&index=0&id=2998e896&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.28.5__cache-loader@4.1.0_web_75d14e9340cbf130d0af91897aeb0542/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2998e896",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ZChart: require('/app/components/zeal/ZChart/ZChart.vue').default})
